import { Navigate, useLocation } from "react-router-dom";

const AuthRoute = ({ children }) => {
  let auth = true;
  let location = useLocation();

  if (!auth) {
    return <Navigate to="/404" state={{ from: location }} />;
  }

  return children;
};

export default AuthRoute;
